import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface MatterUser {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
}

/**
 * Lists every user with access to the matter. Drives the recipient picker in
 * the calendar-invite export modal — backed by the existing
 * `GET /api/matters/:id/users` endpoint.
 */
export const useGetMatterUsers = (matterId: string | undefined) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<MatterUser[], Error>(
    [QueryEntity.MatterUsers, { matterId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matters/${matterId}/users`, fetchConfigGET);
      if (!res.ok) throw new Error('Failed to fetch matter users');
      return res.json();
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
